

export default function MapControlButtons({isClustered, handleClusterView, clearMap, randomCoordenateValue,
    secondRandomCoordenateValue, calculateBestRoute, resetCalculation, analyzeBestRoutes, toggleInput
}) {
    return (
        
        <div style={{display: 'flex', justifyContent: 'space-around', width: '94%', marginLeft: "8px", flexWrap: "wrap"}}>
            <button
                className='calculateButton'
                style={{ marginTop: 10, backgroundColor: isClustered ? "#04AA6D" : "rgb(220, 182, 129)"  }} 
                onClick={handleClusterView}
            >
                Cluster View
            </button>
            
            <button
                className='calculateButton'
                style={{ marginTop: 10}} 
                onClick={clearMap}
            >
                Clear map
            </button>
            
            <button
                disabled={!randomCoordenateValue || !secondRandomCoordenateValue}
                className='calculateButton'
                style={{ marginTop: 10, backgroundColor: (!randomCoordenateValue || !secondRandomCoordenateValue) ? "rgb(220, 182, 129)" : '' }} 
                onClick={calculateBestRoute}
            >
                Calc. Route
            </button>

            <button 
                className='calculateButton'
                style={{ marginTop: 10 }} 
                onClick={resetCalculation}
            >
                Reset Route
            </button>

            <button 
                className='calculateButton'
                disabled={!randomCoordenateValue}
                style={{ marginTop: 10, backgroundColor: (!randomCoordenateValue) ? "rgb(220, 182, 129)" : '' }} 
                onClick={analyzeBestRoutes}
            >
                Analyze Routes
            </button>
            <button 
                className='calculateButton'
                style={{ marginTop: 10 }} 
                onClick={toggleInput}
            >
                Input Data
            </button>
        </div>
    )
}